import { ActionTypes } from '../constants'

// Reducer
function cartReducer(cart = {estimate:{},error:{}}, action) {
    switch (action.type) {
        case ActionTypes.CALC_PRICE:
            return {...cart, estimate:action.estimate, error:action.error };
        default:
            return cart;
    }
}

export default cartReducer


// WEBPACK FOOTER //
// ./src/reducers/cart.js